<div class="container">
  @if(isMobile()){
  <nav>
    <app-navbar />
  </nav>
  } @else {
  <aside>
    <app-navbar />
  </aside>
  }

  <main>
    <div class="content">
      <router-outlet></router-outlet>
      <footer>
        <img [ngSrc]="logoUrl()" [alt]="'MyServy Footer Logo' | translate" class="footer-logo" width="142" height="29">
      </footer>
    </div>
  </main>
</div>